
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h1fbdfea3ad6d664e': html`Мұны
                    <a href="${0}">Folksonomy Engine жобасы</a>әкелді.
                    қатысуға немесе пікір білдіруге тартынбаңыз`,
'h5d824b4954e56ea5': html`Scan your <span class="everyday">everyday</span> <span class="foods">foods</span>`,
'h6bdd1b427aa985a4': html`Бұл құрал ингредиенттер тізімін түзетуге мүмкіндік береді.
                ингредиенттер тізімін қосуға, жоюға немесе өңдеуге болады.
                <br>
                Бұл таңба <span class="highlight">␣</span> бос орынды білдіреді.
                <br>
                Бұл таңба <span class="highlight">↩︎</span> жол үзілімін білдіреді. `,
'hb28f1f2ec1744ee9': html`Бұл сипаттарды пайдаланушылар кез келген түрдегі пайдалану үшін жасайды және жібереді. Өзіңізді қосуға
                    еркін болыңыз. Сіз жасаған сипаттар мен мәндер
                    <strong>шынайы болуы керек</strong>.
                    <a href="${0}">қауымдастық бұрыннан пайдаланған сипаттар тізіміне</a>
                    кіруге немесе
                    <a href="${1}">сипаттарының құжаттамасын және оның іздеу жүйесін</a>зерттеуге болады.`,
's000a5b76bd3a01c2': `Сипаттар жүктелуде...`,
's000d98595e959c1e': `Google Play арқылы алыңыз`,
's013bdc8cf0d3583d': `Ингредиенттерге көмектесіңіз`,
's01d2865e3e1d5501': `Thank you for your assistance!`,
's02ce7a2e7c1b020b': `Кесуді растау`,
's03e9c8114521b998': `Мен ингредиенттерді өңдеймін`,
's05ec315d9308091a': `Штрих-код бұрыштары белгішесі`,
's061eb5af92512c85': `Сақталды! Басқасына көмектесе аласыз ба?`,
's06847c221c4c0bc1': `Мен [пайдалану жағдайыңызды сипаттау] үшін сипат жасағым келеді...`,
's06f6c6f99db6b552': `Түпнұсқа`,
's081e2ad82db71e1d': `Топтастырылған мәндер`,
's09205907b5b56cda': `Жоқ`,
's0b4235aae602a950': `арнайы құжаттама`,
's0bb2d48532acc455': `CSV жүктеп алыңыз`,
's0d5b7fee0311db68': `Property`,
's0fb218abc2e157ed': `Кескінді жарамсыз деп тану`,
's100c4928cc74642a': `support the advancement of public health research.`,
's10db5498186c083b': `Кесуден бас тарту`,
's11a18a69b30b65ed': `Ингредиенттер тізіміндегі қателерді түзетуге көмектесіңіз`,
's1205d5f6fccf8e69': `Меншік құны`,
's15d64a0a6715285a': `Жаңа кілт`,
's166bd56d19670a72': `Zoom`,
's19059bf0c4f7c162': `Таңдау аймағы`,
's1a52515ec8ddade8': `Product barcode`,
's1c5031113de500ce': `keeping our database open &amp; available to all,`,
's1dc4daf989c71284': `Тамақтану туралы ақпаратты түзетуге көмектесіңіз`,
's1e00019dc454872d': `Сипат атауы төлсипатын пайдаланып сипат атын беріңіз.`,
's1e49126af0935a5b': `Осы сипатты пайдаланатын өнімдердің тізімі`,
's21e73088de6f26f3': `Download on the App Store`,
's255857544a9d5ec0': `Reset`,
's25e94495991e95ba': `Thanks for your help! Can you assist with another question?`,
's2ceb11be2290bb1b': `Cancel`,
's2db7b654c0a9bde0': `Мүлікті құжаттау`,
's300b3a6ee4e1252d': str`Нашар сәйкестік ${0}%`,
's33f786bb6b4f0cf4': `Кесу нәтижесі`,
's33f85f24c0f5f008': `Save`,
's34be4af4e8fec4ae': `Алдымен қауымдастықтан сұраңыз`,
's36d86adc823cbfa6': `Жаңа меншікті жасамас бұрын оны қауымдастықпен талқылаңыз:`,
's3781d25aa51a736c': `Folksonomy қозғалтқышының құжаттамасы`,
's383ae4449428b61e': `Кесуді қалпына келтіру`,
's39bcf88721a1e8ee': `Таңдауды қалпына келтіру`,
's39e14e14300694c7': `Құжаттама және нұсқаулықтар`,
's3b430cfa5c1fe7f4': str`${0}үшін құжаттама`,
's3f4e4b52f230a892': `Кескін кенеп`,
's417b90913e05bc17': `Preview`,
's41f7dca46d3f1b4a': `Value`,
's422bba9636ce2489': `Орталық сурет`,
's42dd66b2441566fd': `Орталық белгіше`,
's43df2e8395f6834e': str`Please give to our ${0} Fundraiser`,
's453188ea728f64da': `Add a nutrient`,
's453ab0dbb9b5c777': `Өлшемді оңға өзгерту`,
's475b08749d0706ed': `Help us inform millions of consumers around the world about what they eat`,
's49730f3d5751a433': `Loading...`,
's4bbc7472834a9686': `Your browser does not support barcode scanning.`,
's4d42cc7e00076a3b': `Өнім саны`,
's4df2f533c0c1e7d0': `Кескінді басқару элементтері`,
's4e94adf723979402': `Open Food Facts needs your help with this product.`,
's4f4886341969d552': `Таңдауды жылжыту`,
's4f751fb9b3ed766c': `Жаңа сипатты құру`,
's547c12ae169d00bc': `Available on F-Droid`,
's5560fb119e40923d': `Меншік атауын енгізіңіз...`,
's55d7249883a98ca1': `Open Food Facts викидегі осы мүлік туралы`,
's565867d84c04aea2': `Сипаттарды сүзу...`,
's5666afe5cd0166de': `Растау алдында қателерді түзетіңіз немесе мәтінді өзгертіңіз`,
's57472465a23b41db': `Values`,
's58e1eeea7a60ae51': `Өнімдер жүктелуде...`,
's59df20feee978e5b': `Error: Invalid value.`,
's5c92c0051d44b6de': `Тамақтану туралы ақпаратты түзетуге көмектесіңіз.`,
's5dd6f12783fca34f': `Ингредиенттер тізімін өңдеу`,
's5e8250fb85d64c23': `Close`,
's5ed03bb1f3a15949': `Picture`,
's6306a31415aea913': `I SUPPORT`,
's6498dfe4855bb3a7': `unit`,
's64ef2a6c2dd1d3d1': `Edit`,
's66413c24dcf680e2': `Skip`,
's67ae6594857a4d57': `Thanks for your contribution!`,
's6cee7cad81dfedd1': `Кесілген кескін`,
's6d7b6cdedaadfb6e': `Each donation counts! We appreciate your support in bringing further food transparency in the world.`,
's7124dde792a8faa2': `Android APK`,
's718dea04853f80ae': str`Жақсы сәйкестік ${0}%`,
's71a5c9f4b68ef4d4': `Count`,
's74cb3d66f6a668e1': `Құжаттама`,
's787dd11bed0dc88a': `Өлшемді солға өзгерту`,
's7ce4fd9430e80cea': `value`,
's801a05fa8e881f37': `Мүлікті құру және нұсқаулар туралы көбірек біліңіз:`,
's8038273de2cf8b73': `Қию үшін аймақты таңдаңыз.`,
's839cc2908a5387f2': `Штрихкодтарды сүзу...`,
's86197dcf3e96af64': `Бар сипаттарды шолыңыз және іздеңіз`,
's8a63be30a129a59c': `Төменгі өлшемді өзгерту`,
's8a8bfd67f2dd2810': `Download the OFF app with this QR code`,
's8af61807443f32a4': `Actions`,
's8b33c244759d7bd4': `Жоғарғы оң жақ өлшемін өзгерту`,
's8db84aa4bc949af2': `Жаңа мүлікті құжаттаңыз`,
's8f839a03997a16d7': `Өнімді көру`,
's901ae1e236ac45d3': `Жоюдан бас тарту`,
's907f7a97c6b29425': `Деректер үлгісі өзгертілуі мүмкін екенін ескеріңіз. Өз тәуекеліңізбен пайдаланыңыз.`,
's95d23d03f9147581': `Unzoom`,
's976dfd19ef58a1e1': `Click to scan a barcode and find out its details (health, preferences, etc.)`,
's98ff35f2a00dc60d': `Құрамы:`,
's9a7f60fce090ecaf': `Сипаттар жүктелмеді. Тағы жасауды сәл кейінірек көріңізді өтінеміз.`,
's9b87abd68fb9df45': `Табылмады? {value}жаңа кілт жасаңыз`,
's9c0f52425fd2f07e': `Сәйкес келмеуі мүмкін`,
's9fc41f789c63b40d': `Products`,
'sa1fa766e0d5634d7': `Ұпай жоқ`,
'sa548778b24054030': `Folksonomy Engine жобасының барлық қосылған сипаттарын зерттеңіз. Бұл сипаттар Open Food Facts дерекқорындағы өнімдер туралы қосымша метадеректер мен түсініктерді береді.`,
'sa63907958bd0ec4b': `Жоғарғы сол жақ өлшемін өзгерту`,
'sa95b4224f685a36a': `Модальды жабу`,
'sab56a1d439576fd6': `Ұсыныс белгішесі`,
'sac47ea2901d04c15': `Төменгі сол жақ өлшемін өзгерту`,
'sb125227d436c2925': `Бар сипаттар дерекқорында меншік тұжырымдамасын іздеңіз:`,
'sb125568d43642e6f': `Өнім туралы сұрақтарға жауап беріңіз.`,
'sb1c538e038f9b214': str`Өте жақсы сәйкестік ${0}%`,
'sb28639570ff3b852': `барлық қасиеттердің тізімі`,
'sb3bdd638a58d30f4': `engage a community of committed citizens,`,
'sb3cbcc1bd0fff140': `Меншіктің жоқ екенін және қауымдастық оның пайдалы екенін растағаннан кейін, алдымен оны викиде құжаттау керек.`,
'sb3d4f79d9d8b71e5': `Submit`,
'sb560fa37a7bfb6c2': `Бұл мүлікке арналған өнімдер табылмады.`,
'sb7f72e4c8a2d3357': `Мәндерді сүзу...`,
'sb8178320160f84ea': `Егін көрсету`,
'sbad7d2734149470b': `Validate`,
'sbb623d6b18d966a0': `Nutrition facts are displayed on the packaging:`,
'sbd6be5cde472f37c': `Барлық түсініктемелерге жауап берілді! Көмегіңе рахмет!`,
'sbd9a0b2293b3cd3c': `Порция мөлшері`,
'sbe472dc3c2685985': `Сәйкес мән`,
'sc0520e1732a5c568': `Expand image`,
'sc0cc559e7ede852a': `Жоғарғы өлшемін өзгерту`,
'sc1c08d0cbcc3bd24': `Сәйкес келмейді`,
'sc52696641af72b53': `Install the app!`,
'sc5575e3107f87874': `Rotate image to the left`,
'sc57b630a7a70c61f': `Ұсынылған түзету`,
'sc681b137e8f604f7': `Жоюды растау`,
'sc6daf8a31883f8b9': `Кескінді жылжыту`,
'sc895972c88d38ca5': `Фольксономиялық қасиет`,
'sca0c3305aff570b8': str`per specified serving "${0}"`,
'scace072bef961918': `Жолдар`,
'scb3b0671d7b7f640': `Жаңа мән`,
'scb489a1a173ac3f0': `Иә`,
'scbab4bd737ba7934': str`group photo donation ${0}`,
'scd21019c3cd618f3': `Slack талқылауына қосылыңыз`,
'scdb6cad0b92721bf': `Ешқандай сипат табылмады.`,
'scf23a05631f93732': `Жоюды растаңыз`,
'scfed2f270ef6a3aa': `Аймақты таңдаңыз`,
'sd1022bc1ef9204f7': `Масштабталатын кескін`,
'sd1077c055cf9ba6b': `Өнімнің ингредиенттер тізімін тексеруге көмектесіңіз.`,
'sd698d21ddecba56b': `Эй! Келесі бөліктерге жауап беру арқылы өнім туралы ақпаратты жақсартуға көмектесе аласыз:`,
'sd82bc2decefa621b': `remain independent of the food industry,`,
'sdb97e5976482606e': `Сипаттың бұрыннан бар-жоғын тексеріңіз`,
'sdbf806fefc584115': `Сіз табуыңыз керек`,
'sdc673e73b5c13aea': `Жою`,
'sdc792b75f1edcaba': `Ингредиенттердің емлесін түзетуге көмектесіңіз.`,
'sdca5deead576ceee': `Төменгі оң жақ өлшемін өзгерту`,
'sdcc2555c5dde524f': `Бұл элементті шынымен жойғыңыз келе ме? Бұл әрекетті қайтару мүмкін емес.`,
'se206feec7ec57b28': `per 100g`,
'se419a9ab36987490': `Жарамсыз деп тану`,
'se5127cf0f92e7e48': `Кеңес: сіз де таба аласыз`,
'se773f50d2a16d481': `Rotate image to the right`,
'sebb2c6c830a44574': `technical infrastructure (website/mobile app) &amp; a small permanent team`,
'sec6377f3c4e9b28c': `Мен жақсырақ өнім ұсынамын`,
'seea3800e27baa686': `Жеке өнімдер`,
'sefaba4adc4ec9219': `Фольксономиялық қасиеттер`,
'seffa8ca49175b5f0': `Жекелендірілген қасиеттер`,
'sf44a6b3b232c28ea': str`Ағымдағы мәнді ${0}мәніне ауыстырыңыз`,
'sf4cd86a2f5ef2588': `Өнімнің штрих коды`,
'sf57a61152168cc81': `Ингредиентті анықтауды түзетуге көмектесіңіз`,
'sf88b90b8ba23871c': `Белгісіз сәйкестік`,
'sf9aee319a006c9b4': `Қосу`,
'sfacbbe968fa7d773': `Мүлік атауы:`,
'sfc40ea3d5d5aa6f8': `Your donations fund the day-to-day operations of our non-profit association:`,
'sfe87465d50530725': `Сәйкес мән`,
's5f343a43e7ea9f91': `Error`,
'sd947a599045e9e0e': `Failed to check property conflicts. Please try again.`,
's92a0d19a28995530': `Success`,
's371091f240c17a7e': `Property renamed successfully!`,
's4603f58131a777bf': `Failed to rename property. Please try again.`,
's21694d2ab9c0bec5': `Property deleted successfully!`,
'scf78b75273a6b5fe': `Failed to delete property. Please try again.`,
's71ffcb25fc1c5356': `Rename this property`,
's60320a18282b2b33': `Rename`,
's6e2a82009cc3dfc7': `Delete this property`,
's8bccacf0fc176064': `Rename Property`,
's0df37909a355e56f': str`Rename property '${0}' to:`,
'sb550440eeb3f39c5': `New property name:`,
'sbb53591e587764b7': `Enter new property name...`,
's8acd49e96b4ee7d4': `Check Conflicts`,
'sd1cfdf0ef29cb6a5': `Property Rename Conflicts`,
'sf417737adaa5a8c2': str`Renaming '${0}' to '${1}' will affect:`,
's14571d0ac58a8b43': `Products with both properties:`,
'sb0d459e32656033f': `Products with old property only:`,
'sfa3027dde47305fe': `Products with new property only:`,
's9e5b8feb0892646e': `Do you want to proceed with the rename?`,
's97171907a2d1620b': `Proceed with Rename`,
's712d70fdcc3dd42b': `Delete Property`,
'sc11b78f2f3173f75': str`Are you sure you want to delete the property '${0}'?`,
's3b3fe4e829af3e8e': `This action cannot be undone.`,
's091d3d07b5b3076f': `OK`,
's72c9c4e6ab4ca7ae': `Value replaced successfully!`,
'sdd0eacd725bb2b1d': `Failed to replace value. Please try again.`,
'sfe87a7a8bed11acf': `Value deleted successfully!`,
'sccd2745bdd1087f6': `Failed to delete value. Please try again.`,
's88ece9a678e2f106': `Replace Value`,
's3355d65e22e222c9': str`Replace all instances of '${0}' with a new value:`,
's0d426d718d97d14e': `New value:`,
'se80a1ed3dcab7408': `Enter new value...`,
's2a8434b16dc214a3': `Replace`,
's8263352c7a634e7f': `Delete Value`,
'sebe99e3299746177': str`Are you sure you want to delete all instances of the value '${0}'?`,
's4b0b53abbd6af54a': `Replace this value across all products`,
'sb02836b5e3176cfe': `Delete this value from all products`,
    };
  